<template>
    <div>
        <v-row justify="center" style="box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 1),
    0 24px 38px 3px rgba(0, 0, 0, 1), 0 9px 46px 8px rgba(0, 0, 0, 1) !important;">
            <v-dialog :hide-overlay="false" v-model="open" persistent max-width="400px" style="box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 1),
    0 24px 38px 3px rgba(0, 0, 0, 1), 0 9px 46px 8px rgba(0, 0, 0, 1) !important;">
                <v-card>
                    <v-card-title class="centraliza">
                        <span class="headline">Informe os dados</span>
                    </v-card-title>
                    <v-container>
                        <div class="centraliza" style="flex-wrap: wrap">
                            <v-text-field counter="18" name="input-cnpj" label="CNPJ/CPF" v-model="cnpj"></v-text-field>
                            <v-text-field counter="20" name="input-ie" label="Inscrição Estadual" v-model="ie">
                            </v-text-field>
                            <span>ATENÇÃO: É importante manter a pontuação exatamente como no cadastro do Neo</span>
                        </div>
                    </v-container>
                    <v-card-actions class="centraliza">
                        <v-btn color="#2A5377" style="color: #fff" text @click="$emit('cancel')">Cancelar</v-btn>
                        <v-btn :loading="loading4" :disabled="loading4" color="#2A5377" style="color: #fff" text
                            @click="validate()">
                            Confirmar
                            <v-icon right dark>mdi-cloud-upload</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>
<script>

import * as ClientesService from "../../../providers/clientes.service";

export default {
    props: ["open", "cliente"],
    data: () => ({
        loading4: false,
    }),
    created() {
        this.cnpj = '';
        this.ie = ''
    },
    methods: {
        validate() {
            var self = this;
            self.loading4 = true;

            ClientesService.cadastraDependente({
                CLICODIGO: self.cliente.CLICODIGO,
                CLIDEPCNPJ: self.cnpj,
                CLIDEPIE: self.ie
            })
                .then(r => {
                    self.$emit("success");
                    self.loading4 = false;
                    this.cnpj = '';
                    this.ie = '';
                })
                .catch(err => {
                    self.$emit("cancel");
                    self.loading4 = false;
                });
        }
    }
};
</script>
<style >
.v-dialog {
    -webkit-box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
        0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
    box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
        0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12) !important;
    border-radius: 8px !important;
    margin: 24px !important;
    overflow-y: auto;
    pointer-events: auto;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    width: 100%;
    z-index: inherit !important;
}

.centraliza {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}
</style>